<template lang="pug">
  //- .pa-4.sud-card-body
  v-card-text.sud-card-body
    slot
</template>

<script>
export default {
  name: 'app-card-body'
}
</script>

<style scoped>
.sud-card-body {
  background: #FFFFFF; 
  padding: 8px 16px 8px;
}

.sud-card-body:hover {
  background: #E5E5E5;
  cursor: pointer;
}
</style>


